module.exports = __webpack_public_path__ + "img/power.ad895ef5.svg";